import { useEffect } from "react";
import { X } from "lucide-react";

/** Reusable modal with backdrop, ESC handling, and a close button. */
export default function Lightbox({ open, onClose, children, testId = "lightbox" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
      onClick={onClose}
      data-testid={`${testId}-backdrop`}
    >
      <div
        className="relative w-full max-w-lg bg-demolition-paper border border-demolition-red/40 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        data-testid={testId}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-3 right-3 p-2 text-white/60 hover:text-white hover:bg-white/10 transition-colors"
          data-testid={`${testId}-close`}
        >
          <X className="w-5 h-5" />
        </button>
        {children}
      </div>
    </div>
  );
}
